import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// Directives
import { ArraySectionDirective } from './array-section.directive';
import { DisposableSectionDirective } from './disposable-section.directive';

const DIRECTIVES = [
	ArraySectionDirective,
	DisposableSectionDirective
];

@NgModule({
	declarations: [...DIRECTIVES],
	exports: [...DIRECTIVES],
	imports: [
		CommonModule
	]
})
export class OpenSchemaDirectivesModule { }
